export default __webpack_public_path__ + "static/media/flame-training.e87ec1f1.gif";